import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import UserApi from '@/api/user';
import auth from '@/utils/auth';
import App from '@/utils/app';
import router from '@/router';
import { hasPermission } from '@/utils/permission';
import Utils from '@/utils/utils';
var state = {
  token: auth.getToken() || '',
  userInfo: auth.lsGetUserInfo() || {},
  // 登录用户的个人信息
  realNameInfo: auth.lsGetRealNameInfo() || {},
  // 实名认证信息
  tradePwd: auth.lsGetTradePwd() || '',
  // 用户的交易密码
  keepAliveArrs: [],
  fyWalletInfo: auth.lsGetFYWalletInfo() || {} // 钱包开通状态 0-未开通平台钱包未开通富有钱包 1-已开通平台钱包未开通富有钱包 2-富有钱包开通中 3-已开富有钱包 4-富有钱包开通失败 5-已禁用

};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, data) {
    state.token = data;
  },
  SET_USERINFO: function SET_USERINFO(state, data) {
    state.userInfo = data;
  },
  SET_REALNAMEINFO: function SET_REALNAMEINFO(state, data) {
    state.realNameInfo = data;
  },
  SET_TRADEPWD: function SET_TRADEPWD(state, data) {
    state.tradePwd = data;
  },
  SET_FUIOU_WALLET_INFO: function SET_FUIOU_WALLET_INFO(state, data) {
    state.fyWalletInfo = data;
  },
  SET_KEEP_ALIVE: function SET_KEEP_ALIVE(state, name) {
    if (name && !state.keepAliveArrs.includes(name)) {
      state.keepAliveArrs.push(name);
    }
  },
  REMOVE_KEEP_ALIVE: function REMOVE_KEEP_ALIVE(state, name) {
    if (name && state.keepAliveArrs.includes(name)) {
      state.keepAliveArrs = state.keepAliveArrs.filter(function (x) {
        return x !== name;
      }); // state.keepAliveArrs.splice(state.keepAliveArrs.indexOf(name), 1)
    }
  },
  RESET_KEEP_ALIVE: function RESET_KEEP_ALIVE(state) {
    state.keepAliveArrs = [];
  }
}; // 重置信息

var Reset = function Reset(_ref) {
  var commit = _ref.commit;
  commit('SET_TOKEN', '');
  auth.removeToken();
  commit('SET_USERINFO', {});
  auth.lsRemoveUserInfo();
  commit('SET_REALNAMEINFO', {});
  auth.lsRemoveRealNameInfo();
  commit('SET_FUIOU_WALLET_INFO', {});
  auth.lsRemoveFYWalletInfo();

  if (!Utils.appInfo) {
    // window.localStorage.clear()
    // 点击退出登录时，保留新手指引状态
    Object.keys(window.localStorage).filter(function (item) {
      return item !== 'guide';
    }).forEach(function (item) {
      window.localStorage.removeItem(item);
    });
    window.sessionStorage.clear();
  }

  commit('RESET_KEEP_ALIVE');

  if (Utils.appInfo && !window.location.href.includes('/native/copyWriting')) {
    // app登陆以后需要重新刷新页面获取token
    App.jumpLogin();
  }
};

var actions = {
  // 登录
  Login: function Login(_ref2, userInfo) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      UserApi.login(userInfo).then(function (response) {
        var data = response.data;
        commit('SET_TOKEN', data.token);
        auth.setToken(data.token);
        commit('SET_USERINFO', data);
        auth.lsSetUserInfo(data);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取用户信息
  GetUserInfo: function GetUserInfo(_ref3) {
    var commit = _ref3.commit;
    return new Promise(function (resolve, reject) {
      UserApi.getUserInfo().then(function (response) {
        var data = response.data;
        commit('SET_USERINFO', data);
        auth.lsSetUserInfo(data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取实名信息
  GetRealNameInfo: function GetRealNameInfo(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve, reject) {
      UserApi.getRealNameInfo().then(function (response) {
        var _response$data = response.data,
            data = _response$data === void 0 ? {} : _response$data; // 实名成功

        if (data.status === 's') {
          var userInfoData = auth.lsGetUserInfo();

          if (userInfoData) {
            userInfoData.realNameAuth = true;
            userInfoData.realNameType = data.type;
            commit('SET_REALNAMEINFO', userInfoData);
            auth.lsSetUserInfo(userInfoData);
          }
        }

        commit('SET_REALNAMEINFO', data);
        auth.lsSetRealNameInfo(data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 登出
  Logout: function Logout(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state;
    return UserApi.logout(state.token).finally(function () {
      Reset({
        commit: commit
      });
      router.push('/');
    });
  },
  // 清空信息
  ResetToken: function ResetToken(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve) {
      Reset({
        commit: commit
      });
      resolve();
    });
  },
  // 获取用户交易密码
  GetTradePwd: function GetTradePwd(_ref7) {
    var commit = _ref7.commit;
    return new Promise(function (resolve, reject) {
      UserApi.getTradePasswordStatus().then(function (response) {
        var data = response.data;
        commit('SET_TRADEPWD', data);
        auth.lsSetTradePwd(data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取富友钱包状态
  GetWalletStatus: function GetWalletStatus(_ref8) {
    var commit = _ref8.commit;
    return new Promise(function (resolve, reject) {
      UserApi.getFuYouWallet().then(function (response) {
        var _response$data2 = response.data,
            data = _response$data2 === void 0 ? {} : _response$data2;
        commit('SET_FUIOU_WALLET_INFO', data);
        auth.lsSetFYWalletInfo(data);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 验证用户是否登录 & 实名 & 开通富友钱包 (微应用获取权限调用)
  validPermission: function validPermission(store, data) {
    var _data$scene = data.scene,
        scene = _data$scene === void 0 ? 'realName' : _data$scene;
    return hasPermission(scene, data).finally();
  },
  // 获取app登录状态，未登录跳转到app登录页，登录更新token
  GetAppLogin: function GetAppLogin(_ref9) {
    var commit = _ref9.commit;
    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
      return App.jumpLogin();
    };
    return new Promise(function (resolve, reject) {
      App.getToken({}, function (token) {
        console.log('GetAppLogin token=', token);

        if (token) {
          commit('SET_TOKEN', token);
          auth.setToken(token);
          resolve();
        } else {
          cb && cb();
          reject();
        }
      });
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};